import { useQuery } from "@tanstack/react-query";
import { useUrlBuilder } from "apps/commons/hooks/useUrlBuilder";
import { TanstackQueryKey } from "apps/commons/tanstackQueryKey";
import { type AxiosError, propertySelectionApi } from "libs/api";
import { useSearchParams } from "react-router";
import { useParams } from "router";
import { getCampaignParams } from "./campaignParams";
import { usePropertySelectionViewModelState } from "./propertySelectionViewModelAtom";

export const usePropertySelectionViewModelApi = () => {
    const { lang } = useParams("/:lang/list-my-property");
    const [searchParams] = useSearchParams();
    const [value, setValue] = usePropertySelectionViewModelState();
    const urlBuilder = useUrlBuilder();

    const campaignParams = getCampaignParams(searchParams);

    const { isLoading, isError } = useQuery({
        queryKey: [TanstackQueryKey.GetPropertySelectionViewModel, lang, campaignParams.ocid, campaignParams.e],
        queryFn: () =>
            propertySelectionApi
                .getPropertySelectionViewModel(lang, campaignParams.ocid, campaignParams.e)
                .then((res) => res.data),
        onSuccess: (data) => {
            setValue(data);
        },
        onError: (err: AxiosError) => {
            switch (err.status) {
                case 401:
                case 403:
                    window.location.href = urlBuilder.signInUrl();
                    break;
                default:
                    throw err;
            }
        },
    });

    return {
        isLoading: isLoading || value === undefined,
        isError,
    };
};
